'use client';

import { motion } from 'framer-motion';
import type { HowToSectionData } from '../../types';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell, staggerContainer, staggerItem } from '../section-shared';

export function HowToSection({ section }: { section: HowToSectionData }) {
  return (
    <SectionShell>
      <div className="w-full text-center">
        <h2 className="font-semibold text-[36px] text-white leading-[1.2] sm:text-[28px]">{section.title}</h2>
      </div>
      <motion.div
        className="mt-[42px] grid grid-cols-3 gap-8 sm:mt-8 sm:grid-cols-1 sm:gap-4"
        initial="hidden"
        variants={staggerContainer}
        viewport={{ once: true, margin: '-60px' }}
        whileInView="visible"
      >
        {section.steps?.map((step, index) => (
          <motion.div
            key={step._key || step.title}
            className="min-h-[296px] overflow-hidden rounded-2xl bg-[#1D1D1D] p-7 sm:min-h-0 sm:p-5"
            variants={staggerItem}
          >
            <div className="flex h-8 w-fit items-center justify-center rounded-md border border-[#0086FF] px-2.5 font-medium text-[#0086FF] text-sm leading-[1.2]">
              {`Step ${String(index + 1).padStart(2, '0')}`}
            </div>
            <h3 className="mt-4 min-h-[60px] font-semibold text-[20px] text-white leading-[1.5] tracking-[-0.1px]">
              {step.title}
            </h3>
            <PortableTextContent className="mt-3 text-[15px] leading-[1.5]" value={step.description} />
          </motion.div>
        ))}
      </motion.div>
    </SectionShell>
  );
}
